export const GUIDANCE_DEPTHS = {
  CATEGORY: 'category',
  VENDOR: 'vendor',
  COMPANY: 'company',
};

export const GUIDANCE_VIEWS = {
  RESULTS: 'results',
  REVISIONS: 'revisions',
};

export const DEFAULT_GUIDANCE_NAV = {
  depth: GUIDANCE_DEPTHS.VENDOR,
  view: GUIDANCE_VIEWS.RESULTS,
};

export const GUIDANCE_VIEW_OPTIONS_BY_DEPTH = {
  [GUIDANCE_DEPTHS.CATEGORY]: [
    GUIDANCE_VIEWS.RESULTS,
    GUIDANCE_VIEWS.REVISIONS,
  ],
  [GUIDANCE_DEPTHS.VENDOR]: [
    GUIDANCE_VIEWS.RESULTS,
    GUIDANCE_VIEWS.REVISIONS,
  ],
  [GUIDANCE_DEPTHS.COMPANY]: [
    GUIDANCE_VIEWS.RESULTS,
    GUIDANCE_VIEWS.REVISIONS,
  ],
};

export const isValidGuidanceDepth = (depth) => (
  Object.values(GUIDANCE_DEPTHS).includes(depth)
);

export const isValidGuidanceViewForDepth = (depth, view) => (
  Boolean(GUIDANCE_VIEW_OPTIONS_BY_DEPTH[depth]?.includes(view))
);

export const normalizeGuidanceNav = ({
  depth,
  view,
} = {}) => {
  const normalizedDepth = isValidGuidanceDepth(depth)
    ? depth
    : DEFAULT_GUIDANCE_NAV.depth;
  const normalizedView = isValidGuidanceViewForDepth(normalizedDepth, view)
    ? view
    : GUIDANCE_VIEW_OPTIONS_BY_DEPTH[normalizedDepth]?.[0] || DEFAULT_GUIDANCE_NAV.view;

  return {
    depth: normalizedDepth,
    view: normalizedView,
  };
};

export const buildGuidanceWorkspacePath = ({
  depth,
  view,
  ticker,
} = {}) => {
  const nav = normalizeGuidanceNav({ depth, view });
  const base = `/guidance/${nav.depth}/${nav.view}`;
  const normalizedTicker = String(ticker || '').trim().toUpperCase();
  if (nav.depth !== GUIDANCE_DEPTHS.COMPANY || !normalizedTicker) return base;
  const params = new URLSearchParams();
  params.set('ticker', normalizedTicker);
  return `${base}?${params.toString()}`;
};

export const getGuidanceCompanyPath = ({ ticker, view = GUIDANCE_VIEWS.RESULTS } = {}) => (
  buildGuidanceWorkspacePath({
    depth: GUIDANCE_DEPTHS.COMPANY,
    view,
    ticker,
  })
);
